import React, { useState } from 'react';

// The site sets no cookies and uses no tracking, so this is a purely
// informational notice (not a consent gate). It remembers dismissal in
// localStorage so it doesn't reappear. Styled like the GDPR overlay, small.
export default function Claimer (props) {
  const isBrowser = typeof window !== 'undefined';

  const [read, setRead] = useState(() => {
    if (isBrowser) return !!localStorage.getItem('confirmation');
    return false;
  });

  function dismiss () {
    setRead(true);
    if (isBrowser) localStorage.setItem('confirmation', 'true');
  }

  if (read) return null;

  return (
    <div className="cookie-banner">
      <h2 className="cookie-title">Datenschutz</h2>
      <p className="cookie-text">
        Diese Website verwendet keine Cookies und keine Tracking- oder
        Analyse-Dienste. Schriften werden lokal geladen — es werden keine Daten
        an Dritte übertragen.
      </p>
      <div className="cookie-actions">
        <button type="button" className="cookie-btn" onClick={() => props.open()}>
          Datenschutzerklärung
        </button>
        <button type="button" className="cookie-btn" onClick={dismiss}>
          Verstanden
        </button>
      </div>
    </div>
  );
}
